'use strict';
import angular from 'angular';
import {LinkEditarComponent} from './link-editar.component'

export default angular.module('pizzutoAutopartesApp.link-editar', [])
    .component(LinkEditarComponent.selector, LinkEditarComponent)
    .name;


// WEBPACK FOOTER //
// ./client/components/link-editar/index.js